/**
 * Klasa do zapisywania loklanej konfiguracji Aplikacji.
 */
export class Config {
    /**
     * Nazwa pola pokazywanego na karcie kierowcy.
     */
    public DriverCardColumn?: number;

    /**
     * Nazwa pola pokazywanego na karcie pojazdu.
     */
    public VehicleCardColumn?: number;

    /**
     * Nazwy pól pokazywanych na liście FULL pojazdów.
     * z domyślnymi
     */
    public VehicleFullListColumns: Array<any> = [13, 2, 11, 12, 1, 4, 19, 14, 15, 8, 7, 17, 3, 16];

    public VehicleFullListColumnsOrder: Array<any> = [13, 2, 11, 12, 1, 4, 19, 14, 15, 8, 7, 17, 3, 16];
}
